module.exports = __webpack_public_path__ + "static/design-cal-34d08c1df15424908c7e8492ef232e3b.jpg";